var _defs, _rect, _rect2, _rect3, _path, _polygon, _rect4, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2c3a41;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #ff8a15;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.88,
    y: 4.67,
    width: 92.97,
    height: 30.99
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 416.52,
    y: 43.41,
    width: 30.99,
    height: 116.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 370.04,
    y: 4.9,
    width: 123.96,
    height: 30.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.26,69.02c-24.03-5.72-27.82-5.95-27.82-20.6,0-11.22,3.43-12.76,18.77-12.76,4.09,0,8.21,0,11.85.78l.18-30.94c-3.05-.83-5.51-.83-9.39-.83-41.89,0-52.64,12.39-52.64,42.83,0,32.96,5.49,40.28,42.34,48.3,24.95,5.49,27.49,6.32,27.49,20.05,0,12.82-7.17,12.78-24.8,12.78-5.27,0-9.3,0-13.95-.77v30.99c4.65.78,8.89.78,13.82.78,48.16,0,55.85-13.33,55.85-43.54s-.51-37.22-41.71-47.06"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.88 107.37 36.88 159.63 67.87 159.63 67.87 105.39 36.88 105.39 36.88 74.4 6.67 89.54 15.08 118.96 36.88 107.37"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.88,
    y: 74.4,
    width: 77.48,
    height: 30.99
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.32,66.52v-22.99c0-21.47-17.4-38.87-38.87-38.87h-38.61v30.99h31.83c8.1,0,14.66,6.56,14.66,14.66v9.42c0,8.09-6.56,14.66-14.66,14.66h-31.83v30.99h11.5l39.63,54.24,26.34-20.92-25.65-35.8c1.97-.46,3.47-1.01,4.25-1.66,12.69-6.4,21.41-19.54,21.41-34.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrst);
export default __webpack_public_path__ + "static/media/frst.28d2be1345d180e09c2ebc7dd4befdc2.svg";
export { ForwardRef as ReactComponent };